<template>
  <!-- <div id="trackingMap" class="tracking-map">
    <tracking-search
      @handleSerch="handleSerch"
    />
    <tracking-status ref="trackingStatus" />
  </div> -->
  <div class="app-container">
    <iframe
      id="trackingMap" 
      :src="srcUrl"
      frameborder="0"
      allowfullscreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    />
  </div>
</template>

<script>
/* global AMap */
// import iconCar from '@/assets/img/icon/car_right.png'
// import iconFawarehouse from '@/assets/img/icon/icon_fawarehouse.png'
// import iconShouwarehouse from '@/assets/img/icon/icon_shouwarehouse.png'
// import { point, midpoint } from '@turf/turf'
// import moment from 'moment'
// import iconNote from '@/assets/img/icon/icon_fill_notes.png'
// import TrackingSearch from './components/Search.vue'
// import TrackingStatus from './components/Status.vue'
// import { STATUSPARAM, STATUSTEXT } from './const'
// import { getGoodBatch } from './api'
import Service from '../../../../env/index'

export default {
  name: 'GoodsTracking',
  components: {
    // TrackingSearch,
    // TrackingStatus
  },
  data() {
    return {
      // map: null,
      // fetchNumber: 10, // 每次请求条数
      srcUrl: ''
    }
  },
  mounted() {
    let customerCode = ''
    const {user} = this.$store.state || {}
    if (user.customers?.length) {
      customerCode = user.customers[0].customerCode
    } else {
      customerCode = user.customerCode
    }
    const token = this.$store.state?.user?.token || ''
    this.srcUrl = `${Service.IFRAME_ORIGIN}/#/consignorView?appToken=${token}&customerCode=${customerCode}`
    // this.map = new AMap.Map('trackingMap', {
    //   resizeEnable: true,
    //   zoom: 5,
    //   mapStyle: 'amap://styles/5415d2af821d8107c2bafa18f73bcf5b',
    // })
  },
  methods: {
    // clearMarker() {
    //   if (!this.map) {
    //     return
    //   }
    //   this.map.remove(this.map.getAllOverlays('marker'))
    //   this.map.remove(this.map.getAllOverlays('polyline'))
    // },
    // setMarker({ image, content, sizeX, sizeY, position }) {
    //   const markerIcon = new AMap.Icon({
    //     size: new AMap.Size(sizeX, sizeY),
    //     image,
    //     imageSize: new AMap.Size(sizeX, sizeY),
    //   })
    //   const marker = new AMap.Marker({
    //     position,
    //     icon: markerIcon,
    //     offset: new AMap.Pixel(-sizeX/2, -sizeY),
    //     label: {
    //       content,
    //     }
    //   })
    //   return marker
    // },
    // async handleSerch(val) {
    //   this.$refs.trackingStatus.hide()
    //   this.clearMarker()
    //   // 请求出全部数据
    //   this.$message.warning({
    //     content: '线路正在加载中！',
    //     duration: 0,
    //     icon: (h) => h(
    //       'img', {attrs: {src: iconNote, class: 'message-icon'}}
    //     ),
    //   })
    //   try {
    //     const res = await getGoodBatch(val)
    //     if (res.length) {
    //       const result = this.getMapList(res)
    //       this.$message.destroy()
    //       this.$message.success('已加载成功！')
    //       this.renderMarker(result)
    //     } else {
    //       // 没有查询记录
    //       this.$message.destroy()
    //       this.$message.warning('此时段内，查询货品无操作信息记录！')
    //     }
    //   } catch {
    //     this.$message.destroy()
    //     this.$message.error('加载失败！')
    //   }
    // },
    // getMapList(list) {
    //   const result = {}
    //   list.forEach(item => {
    //     const { TRANSPORTING, SIGNED } = STATUSPARAM
    //     if ((item.endStationLatitude && item.endStationLongitude) || (item.status !== TRANSPORTING && (!item.endStationLatitude || !item.endStationLongitude))) {
    //       const status = [TRANSPORTING, SIGNED].includes(item.status) ? item.status : 'other'
    //       if (!result[item.warehouseId]) {
    //         result[item.warehouseId] = {
    //           ...item,
    //           endList: {}
    //         }
    //       }
    //       const {endList} = result[item.warehouseId]
    //       if (!endList[item.endStationCode]) {
    //         endList[item.endStationCode] = { item }
    //       }
    //       const endStation = endList[item.endStationCode]
    //       if (!endStation[status]) {
    //         endStation[status] = {
    //           item,
    //           statusList: [],
    //           list: [],
    //         }
    //       }
    //       endStation[status].list.push(item)
    //       if (!endStation[status].statusList.includes(item.status)) {
    //         endStation[status].statusList.push(item.status)
    //       }
    //     }
    //   })
    //   return result
    // },
    // getMidPoint(startLong = 0, startLat = 0, endLong = 0, endLat = 0) {
    //   const startPoint = point([startLong, startLat]);
    //   const endPoint = point([endLong, endLat]);
    //   const middlePoint = midpoint(startPoint, endPoint);
    //   return middlePoint.geometry.coordinates
    // },
    // renderLine(lineArr) {
    //   const polyline = new AMap.Polyline({
    //     path: lineArr,            // 设置线覆盖物路径
    //     strokeColor: '#06B880',   // 线颜色
    //     strokeOpacity: 1,         // 线透明度
    //     strokeWeight: 4,          // 线宽
    //     strokeStyle: 'solid',     // 线样式
    //   });
    //   polyline.setMap(this.map);
    // },
    // getMarker() {
    //   setTimeout(() => {
    //     const marker = document.getElementsByClassName('marker-click')
    //     marker.forEach(el => {
    //       el.addEventListener("click", (e) => {
    //         const current = document.getElementsByClassName('current-marker')
    //         current.forEach(c => {
    //           c.classList.remove('current-marker')
    //           c.classList.remove('info-current')
    //         })
    //         const item = JSON.parse(e.currentTarget.dataset.item)
    //         const {key} = e.currentTarget.dataset
    //         const className = 'info-current'
    //         e.currentTarget.classList.add(className)
    //         e.currentTarget.classList.add('current-marker')
    //         this.markerClick(item, key)
    //       },false);
    //     })
    //   }, 300);
    // },
    // removeMarker() {
    //   const marker = document.getElementsByClassName('marker-click')
    //   marker.forEach(el => {
    //     const item = el
    //     item.onclick = null
    //   })
    // },
    // markerClick(item, key) {
    //   this.$refs.trackingStatus.show(item, key)
    // },
    // getBadge(number) {
    //   return number > 1 ? `<p class="badge">${number > 99 ? "99+": number}</p>` : ''
    // },
    // getTransportMarker(current, key) {
    //   const { item, list } = current
    //   const time = list.sort((a, b) => a.actionTime - b.actionTime)[0]?.actionTime
    //   const markerList = []
    //   const {warehouseLongitude = 0, warehouseLatitude = 0} = item
    //   const endStationLongitude = item.endStationLongitude || warehouseLongitude
    //   const endStationLatitude = item.endStationLatitude || warehouseLatitude
    //   const position = this.getMidPoint(warehouseLongitude, warehouseLatitude, endStationLongitude, endStationLatitude)
    //   const content = `<div class="marker-transport marker-click marker-content"
    //   data-item='${JSON.stringify(current)}' data-key=${key}>
    //   <a class="transport-status">运输中</a>
    //   <p class="marker-time">${time ? moment(time).format('YYYY-MM-DD') : ''}</p>
    //   ${
    //     this.getBadge(list.length)
    //   }
    //   <div class="marker-arrow"></div>
    //   </div>`
    //   const marker = this.setMarker({
    //     image: iconCar,
    //     content,
    //     sizeX: 80,
    //     sizeY: 80,
    //     position,
    //   })
    //   markerList.push(marker)
    //   const wahoseMarker = this.setMarker({
    //     image: iconShouwarehouse,
    //     content: '',
    //     sizeX: 40,
    //     sizeY: 44,
    //     position: [endStationLongitude, endStationLatitude],
    //   })
    //   markerList.push(wahoseMarker)
    //   this.renderLine([[warehouseLongitude, warehouseLatitude],position])
    //   return markerList
    // },
    // getStatusText(statusList) {
    //   let status = ''
    //   const { IN_WAREHOUSE, OUT_WAREHOUSE, STAY_IN_WAHOUSE } = STATUSPARAM
    //   const index = statusList.indexOf(STAY_IN_WAHOUSE)
    //   if (index > -1) {
    //     statusList.splice(index, 1)
    //   }
    //   if(statusList.length === 1) {
    //     status = STATUSTEXT[statusList[0]]
    //   } else if (statusList.includes(IN_WAREHOUSE) && statusList.includes(OUT_WAREHOUSE)) {
    //     status = '出/入库中'
    //   }
    //   return status
    // },
    // getAMarker(current, key) {
    //   const { item, list, statusList } = current
    //   const {
    //     warehouseLongitude = 0,
    //     warehouseLatitude = 0,
    //     warehouseName,
    //   } = item
    //   const endStationLongitude = item.endStationLongitude || warehouseLongitude
    //   const endStationLatitude = item.endStationLatitude || warehouseLatitude
    //   const endStationName = item.endStationName || warehouseName
    //   const statusText = statusList.length === 1 ? STATUSTEXT[statusList[0]] : this.getStatusText(statusList)
    //   let timeText = ''
    //   let time = 'actionTime'
    //   if (statusList.length === 1) {
    //     if (key === STATUSPARAM.SIGNED) {
    //       time = 'signTime'
    //     }
    //   }
    //   timeText = list.sort((a, b) => b[time] - a[time])[0]?.[time]
    //   const content = `<div class="marker-info marker-content marker-click flex"
    //   data-item='${JSON.stringify(current)}' data-key=${key}>
    //   <div class="marker-info-content">
    //   <a class="ellipsis warehouse-name">${endStationName}</a>
    //   <p class="marker-time">
    //   ${
    //     timeText ? 
    //     `<span class="action-time">${moment(timeText).format('YYYY-MM-DD')}</span>`
    //     : 
    //     ''
    //   }
    //   <span class="marker-status">${statusText}</span>
    //   </p>
    //   ${
    //     this.getBadge(list.length)
    //   }
    //   <div class="marker-arrow"></div>
    //   </div>`
    //    const marker = this.setMarker({
    //     image: iconShouwarehouse,
    //     content,
    //     sizeX: 40,
    //     sizeY: 44,
    //     position: [endStationLongitude, endStationLatitude]
    //   })
    //   if (key === STATUSPARAM.SIGNED) {
    //     this.renderLine([[warehouseLongitude, warehouseLatitude],[endStationLongitude, endStationLatitude]])
    //   }
    //   return [marker]
    // },
    // renderStation(list) {
    //   let markerList = [];
    //   const keys = Object.keys(list)
    //   // 运输中
    //   if (keys.includes(STATUSPARAM.TRANSPORTING))  {
    //     const current = list[STATUSPARAM.TRANSPORTING]
    //     const transportMarker = this.getTransportMarker(current, STATUSPARAM.TRANSPORTING)
    //     markerList = markerList.concat(transportMarker)
    //   }
    //   // 已签收
    //   if (keys.includes(STATUSPARAM.SIGNED)) {
    //     const current = list[STATUSPARAM.SIGNED]
    //     const signMarker = this.getAMarker(current, STATUSPARAM.SIGNED)
    //     markerList = markerList.concat(signMarker)
    //   }
    //   if (keys.includes('other')) {
    //     const current = list.other
    //     const otherMarker = this.getAMarker(current, 'other')
    //     markerList = markerList.concat(otherMarker)
    //   }
    //   return markerList
    // },
    // renderMarker(list) {
    //   this.removeMarker()
    //   let markerList = []
    //   Object.keys(list).forEach(listItem => {
    //     const item = list[listItem]
    //     const { warehouseLatitude = 0, warehouseLongitude = 0} = item
    //     if (item.endStationLongitude && item.endStationLatitude) {
    //       const content = `<div class="marker-house marker-content">
    //         <div class="ellipsis">${item.warehouseName}</div>
    //         <div class="marker-arrow"></div>
    //         </div>`
    //       const marker = this.setMarker({
    //         image: iconFawarehouse,
    //         content,
    //         sizeX: 40,
    //         sizeY: 44,
    //         position:[warehouseLongitude || 0, warehouseLatitude || 0]
    //       })
    //       markerList.push(marker)
    //       Object.keys(item.endList).forEach(endItem => {
    //         const end = item.endList[endItem]
    //         const endMarker = this.renderStation(end)
    //         markerList = markerList.concat(endMarker)
    //       })
    //     } else {
    //       Object.keys(item.endList).forEach(endItem => {
    //         const end = item.endList[endItem]
    //         const endMarker = this.renderStation(end)
    //         markerList = markerList.concat(endMarker)
    //       })
    //       // const content = `<div class="marker-house marker-content">
    //       //   <div class="ellipsis">${item.warehouseName}</div>
    //       //   <div class="marker-arrow"></div>
    //       //   </div>`
    //       // const marker = this.setMarker({
    //       //   image: iconShouwarehouse,
    //       //   content,
    //       //   sizeX: 40,
    //       //   sizeY: 44,
    //       //   position:[warehouseLongitude || 0, warehouseLatitude || 0]
    //       // })
    //       // markerList.push(marker)
    //     }
    //   })
    //   this.map.add(markerList);
    //   this.map.setFitView(markerList)
    //   this.getMarker()
    // },
  }
}
</script>
<style scoped>
#trackingMap {
  width: 100%;
  height: 100%;
  display: block;
}
.app-container {
  padding: 0 24px;
  height: calc(100vh - 80px);
}
</style>
<!-- <style>
.message-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
</style>

<style lang="less" scoped>
.tracking-map {
  width: 100%;
  height: calc(100vh - 104px);
  /deep/.amap-marker {
    .amap-icon {
      overflow: visible !important;
    }
    .amap-marker-label {
      position: absolute;
      border: none;
      padding: 0;
      .marker-content {
        padding: 8px 6px;
        border-radius: 4px;
        background: #fff;
        position: absolute;
        box-shadow: 0px 0px 6px 0px rgba(160, 184, 194, 0.5);
        .badge {
          position: absolute;
          right: -9px;
          top: -9px;
          padding: 0 5px;
          height: 17px;
          line-height: 17px;
          background: #FF0000;
          color: #fff;
          border-radius: 8px;
        }
        .marker-arrow {
          display: inline-block;
          width: 0px;
          height: 0px;
          position: absolute;
          left: 50%;
          bottom: -3px;
          width: 6px;
          height: 6px;
          background: #fff;
          transform: translateX(-50%) rotate(45deg);
          border-radius: 2px;
        }
        &.current-marker {
          .marker-time, .transport-status, .marker-info-content .warehouse-name {
            color: #fff;
          }
        }
        &.info-current {
          background: #FB9432;
          .marker-arrow {
            background: #FB9432;
          }
          &.marker-transport {
            background: #06B880;
            .marker-arrow {
              background: #06B880;
            }
          }
        }
        .ellipsis {
          max-width: 120px;
        }
      }
      .marker-time {
        color: #909399;
        line-height: 14px;
      }
      .marker-house {
        font-weight: 500;
        transform: translateX(-50%);
        font-size: 14px;
        color: #171717;
        top: -30px;
        left: 20px;
      }
      .marker-transport {
        top: -35px;
        &:hover {
          border: 1px solid #06B880;
          .marker-arrow {
            border-bottom: 1px solid #06B880;
            border-right: 1px solid #06B880;
          }
        }
        .transport-status {
          font-weight: 500;
          color: #06B880;
          font-size: 14px;
          text-decoration: underline;
          line-height: 17px;
        }
      }
      .marker-info {
        padding: 0;
        top: -56px;
        left: 20px;
        transform: translateX(-50%);
        &:hover {
          border: 1px solid #FB9432;
          .marker-arrow {
            border-bottom: 1px solid #FB9432;
            border-right: 1px solid #FB9432;
          }
        }
        .marker-info-content {
          padding: 8px;
          .warehouse-name {
            font-weight: 500;
            color: #FB9432;
            font-size: 14px;
            text-decoration: underline;
            line-height: 17px;
            display: inline-block;
            width: 100%;
          }
          .action-time {
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style> -->
